export enum SystemCountryCodeFormat {
  SE = "se",
  NO = "no",
}
